module.exports = __webpack_public_path__ + "static/img/F.80008b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/F.png
// module id = vAUz
// module chunks = 0